import { render } from "./BFormSelect.vue?vue&type=template&id=38629661&scoped=true&ts=true"
import script from "./BFormSelect.vue?vue&type=script&lang=ts"
export * from "./BFormSelect.vue?vue&type=script&lang=ts"

import "./BFormSelect.vue?vue&type=style&index=0&id=38629661&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38629661"]])

export default __exports__